import { getHasBasicSubscription } from 'nove8/helpers/getHasBasicSubscription'
import { useEffect } from 'react'
import { cancelCalendlyEvent } from 'services/calendly.service'
import { useZustandStore } from 'zustandGlobalStore'

export const useDestroyBeforeUnmountComponent = (): void => {
  const leadSubscriptions = useZustandStore(
    (state) => state.lead?.subscriptions,
  )

  useEffect(
    () => () => {
      const isNotPaid = !getHasBasicSubscription(leadSubscriptions || null)
      // || !localStorage.getItem(IS_USER_HAS_SUBSCRIPTION) - TODO:move to zustand when VC is implementing

      window.addEventListener('beforeunload', async (event) => {
        if (isNotPaid) {
          await cancelCalendlyEvent()
        }
        event.preventDefault()
      })
    },
    [leadSubscriptions],
  )
}
